import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getServiceOrderCategory, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { FeatureToggles, useFeatureToggle } from '../../../../../configuration/featureToggle/toggleHook';
import { ServiceCategory } from '../commonServiceOrder.types';

export const ServiceOrderCategoriesSelection = () => {
    const dispatch = useAppDispatch();
    const category = useAppSelector(getServiceOrderCategory);
    const isServiceOptionsEnabled = useFeatureToggle(FeatureToggles.SERVICE_OPTIONS, false).value;

    const handleCategoryClick = (selectedCategory: ServiceCategory) => () => {
        dispatch(serviceOrdersSlice.actions.setCategory(selectedCategory));
    };

    return (
        <div className="btn-group" role="tablist">
            <Button
                role="tab"
                active={category === ServiceCategory.CURRENT}
                onClick={handleCategoryClick(ServiceCategory.CURRENT)}
            >
                <span className="rioglyph rioglyph-document" />
                <FormattedMessage id="outboundPortal.serviceOrders.table.toolbar.current" />
            </Button>
            {isServiceOptionsEnabled && (
                <Button
                    role="tab"
                    active={category === ServiceCategory.OPTIONS}
                    onClick={handleCategoryClick(ServiceCategory.OPTIONS)}
                >
                    <span className="rioglyph rioglyph-group" />
                    <FormattedMessage id="outboundOrderBook.serviceOrders.table.toolbar.serviceOptions" />
                </Button>
            )}
            <Button
                role="tab"
                active={category === ServiceCategory.ARCHIVE}
                onClick={handleCategoryClick(ServiceCategory.ARCHIVE)}
            >
                <span className="rioglyph rioglyph-folder-closed" />
                <FormattedMessage id="outboundOrderBook.common.table.toolbar.archive" />
            </Button>
        </div>
    );
};
